var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87823 4.30769C1.87823 2.96604 2.9719 1.87453 4.31621 1.87453H23.7391C25.0835 1.87453 26.1771 2.96604 26.1771 4.30769V23.6923C26.1771 25.034 25.0835 26.1255 23.7391 26.1255H4.31621C2.9719 26.1255 1.87823 25.034 1.87823 23.6923V4.30769ZM23.7391 0H4.31621C1.93244 0 0 1.92862 0 4.30769V23.6923C0 26.0714 1.93244 28 4.31621 28H23.7391C26.1229 28 28.0554 26.0714 28.0554 23.6923V4.30769C28.0554 1.92862 26.1229 0 23.7391 0ZM19.3364 6.58142H8.71779C8.15464 6.58142 7.61456 6.80468 7.21635 7.2021C6.81815 7.59952 6.59444 8.13854 6.59444 8.70057V19.2982C6.59444 19.8602 6.81815 20.3993 7.21635 20.7967C7.61456 21.1941 8.15464 21.4174 8.71779 21.4174H19.3373C19.9005 21.4174 20.4406 21.1941 20.8388 20.7967C21.237 20.3993 21.4607 19.8602 21.4607 19.2982V8.70057C21.4607 8.4222 21.4057 8.14656 21.299 7.88939C21.1922 7.63222 21.0357 7.39856 20.8384 7.20177C20.6412 7.00498 20.407 6.8489 20.1492 6.74246C19.8915 6.63602 19.6153 6.58129 19.3364 6.58142Z",
    fill: "#1E6EFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcheckIcon);
export default __webpack_public_path__ + "static/media/procheck-icon.42b38efdbd986cb055f60980517cb4af.svg";
export { ForwardRef as ReactComponent };